import React from 'react';
import { Helmet } from 'react-helmet';
import styled, { StylesProps, cx } from '../../../lib/styles';
import { Color, Brand } from '../../../lib/theme';
import Button from '../Button';
import Icon, { IconProps } from '../Icon';
import Fab from '../Popup/Fab';
import modalStyles from './Modal_styles';

interface FooterButton {
  label: string;
  color?: Color;
  icon?: IconProps | null;
  type: 'button' | 'submit';
  disabled: boolean;
  onClick?: (e?: any) => any;
}

export interface ModalProps {
  brand?: Brand;
  className?: string;
  backgroundColor?: string;
  size?: 's' | 'm' | 'l';
  center?: boolean;
  Backdrop?: any;
  backdropProps?: any;
  onClose?: () => any;
  scrollRef?: (elem: any) => any;
  header?: React.ReactNode;
  children: React.ReactNode;
  footer?: FooterButton[];
  innerWidth?: number;
  innerPadding?: number;
  overflowX?: 'visible' | 'hidden' | 'auto' | 'scroll';
}

const Modal = ({
  brand = 'sas',
  scrollRef,
  className,
  onClose,
  header,
  children,
  footer,
  styles,
}: ModalProps & StylesProps<typeof modalStyles>) => (
  <div className={cx('Modal', styles.container, className)}>
    <Helmet htmlAttributes={{ class: 'starlord_modal_open' }} />

    <div
      className={cx(styles.backdrop, 'backdrop')}
      onClick={() => onClose && onClose()}
    />

    <div className={cx(styles.modalBody, `modalBody`)}>
      <div className={cx(styles.toolbar, 'toolbar')}>
        {onClose && (
          <Fab
            brand={brand}
            icon={{ name: 'close', className: 'las la-times' }}
            color={`primary`}
            onClick={onClose}
          />
        )}
      </div>

      <div className={cx(styles.modalContent, 'modalContent')}>
        {header && (
          <div className={cx(styles.modalHeading, 'modalHeading')}>
            {header}
          </div>
        )}
        <div
          ref={scrollRef}
          className={cx(styles.childrenContainer, 'childrenContainer')}
        >
          {children}
        </div>
        {footer && (
          <div className={cx(styles.modalFooter, 'modalFooter')}>
            {footer.map(button => {
              const { label, type, icon, disabled, color, onClick } = button;
              return (
                <Button
                  key={label}
                  type={type}
                  color={color || 'primary'}
                  disabled={disabled || false}
                  className={cx('modalFooterButton')}
                  onClick={e => onClick && onClick(e)}
                >
                  {icon && <Icon {...icon} />}
                  {label}
                </Button>
              );
            })}
          </div>
        )}
      </div>
    </div>
  </div>
);

export default styled(modalStyles)(Modal);
